import axios from "axios";
import config from "./config";

type EntityApiByParams = {
    filter?: {},
    sort?: {},
    page?: number,
    size?: number
}

const EntityApi = {

    STATUS_SUCCESS: 'success',
    STATUS_FAIL: 'fail',

    get: async (entity: string, id: number) => {
        try {
            const axiosConfig = {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('token')
                }
            };
            const response = await axios.get(config.host + '/api/' + entity + '/' + id, axiosConfig);
            return response.data;
        } catch (error) {
            throw new Error('Unable to get EntityApi - ' + entity + ': id ' + id);
        }
    },

    getBy: async (entity: string, {filter, sort = {id: 'desc'}, page = 1, size = 10} : EntityApiByParams) => {
        const uri = config.host + '/api/' + entity;
        try {
            const axiosConfig = {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('token')
                }
            };
            const response = await axios.post(uri, JSON.stringify({
                filter: filter,
                sort: sort,
                page: page,
                size: size
            }), axiosConfig);
            return response.data;
        } catch (error) {
            throw new Error('Unable to getBy EntityApi [' + uri + '] - ' + entity + ': filter ' + filter + ', sort ' + sort + ', page ' + page);
        }
    },

    put: async (entity: string, fields: {}) => {
        const uri = config.host + '/api/' + entity;
        try {
            const axiosConfig = {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('token')
                }
            };
            const data = JSON.stringify(fields);
            const response = await axios.put(uri, data, axiosConfig);
            return response.data;
        } catch (error) {
            throw new Error('Unable to put EntityApi [' + uri + '] - ' + ': fields ' + fields);
        }
    },

    post: async (entity: string, id: number, fields: {}) => {

        const uri = config.host + '/api/' + entity + '/' + id;
        try {
            const axiosConfig = {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('token')
                }
            };
            const data = JSON.stringify(fields);
            const response = await axios.post(uri, data, axiosConfig);
            return response.data;
        } catch (error) {
            throw new Error('Unable to post EntityApi [' + uri + '] - ' + ': fields ' + fields);
        }

    },

    delete: async (entity: string, id: number) => {
        const uri = config.host + '/api/' + entity + '/' + id;
        try {
            const axiosConfig = {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('token')
                }
            };
            const response = await axios.delete(uri, axiosConfig);
            return response.data;
        } catch (error) {
            throw new Error('Unable to delete EntityApi [' + uri + ']');
        }
    }


}

export default EntityApi;
